import { Button, Tab, Tabs, Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import Page from '../../../components/Page'
import TabPanel from '../../../components/containers/TabPanel'
import PlusIcon from '../../../components/icons/PlusIcon'
import { BrandsPanel } from '../../../components/routes/categories/BrandsPanel'
import { CategoriesPanel } from '../../../components/routes/categories/CategoriesPanel'
import { InternalCategoriesPanel } from '../../../components/routes/categories/InternalCategoriesPanel'
import { ReapproCategoriesPanel } from '../../../components/routes/categories/ReapproCategoriesPannel'
import { useRights } from '../../../utils/hooks'
import { fonts } from '../../../utils/theme/fonts.theme'

import { withResourcePermission } from '../../../components/RequireResourcePermission'
const tabs = ['categories', 'internal', 'reappro', 'brands'] as const
type Tab = (typeof tabs)[number]

export const Route = createFileRoute('/_authenticated/categories/')({
  component: withResourcePermission('categories', 'read')(CategoriesPage),
  validateSearch: z.object({
    tab: z.enum(tabs).optional().default('categories'),
  }),
})

function CategoriesPage() {
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const newTab = tabs.at(newValue) ?? 'categories'
    navigate({ search: { tab: newTab } })
  }

  const isAdmin = useRights(['ADMIN'])

  return (
    <Page>
      <div style={{ display: 'flex' }}>
        <Typography style={fonts.pageTitle} flexGrow={1}>
          Catégories
        </Typography>

        {tab === 'categories' && (
          <Button
            variant="contained"
            onClick={() => navigate({ to: '/categories/new' })}
            disabled={!isAdmin}
          >
            <PlusIcon />
            Ajouter une catégorie
          </Button>
        )}
        {tab === 'brands' && (
          <Button
            variant="contained"
            sx={{ marginRight: '16px' }}
            onClick={() => navigate({ to: '/categories/brand/new' })}
            disabled={!isAdmin}
          >
            <PlusIcon />
            Ajouter une marque
          </Button>
        )}
      </div>

      <Tabs value={tabs.indexOf(tab)} onChange={handleChange}>
        <Tab label="Catégories" />
        <Tab label="Catégories internes" />
        <Tab label="Catégories réappro" />
        <Tab label="Marques" />
      </Tabs>

      <TabPanel value={tab} index="categories">
        <CategoriesPanel />
      </TabPanel>

      <TabPanel value={tab} index="internal">
        <InternalCategoriesPanel />
      </TabPanel>

      <TabPanel value={tab} index="reappro">
        <ReapproCategoriesPanel />
      </TabPanel>

      <TabPanel value={tab} index="brands">
        <BrandsPanel />
      </TabPanel>
    </Page>
  )
}

export default CategoriesPage
